import $ from "jquery";

/**
 * Fetch all users in the current user's organization
 * Handles pagination automatically to retrieve all users
 *
 * @returns {Promise<Array>} Array of user objects with id, name, email, admin, suspended, role, etc.
 */
export function getOrganizationUsers() {
    const results = [];
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request
        return $.ajax({
            url: '/api/users/list',
            dataType: 'json',
            data: {
                pagination_token: pagination_token
            }
        }).promise().then(users_json => {
            // Gather the results from this query and stash them in the output object
            for (const index in users_json.data.users) {
                results.push({
                    id: users_json.data.users[index].id,
                    name: users_json.data.users[index].name,
                    email: users_json.data.users[index].email,
                    role: users_json.data.users[index].role,
                    admin: users_json.data.users[index].admin,
                    suspended: users_json.data.users[index].suspended,
                    status: users_json.data.users[index].status,
                    last_sign_in_at: users_json.data.users[index].last_sign_in_at,
                    policies: users_json.data.users[index].policies
                });
            }

            // Break out of this recursive loop if we've found everything
            if (users_json.data.pagination_token == null) {
                return results;
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(users_json.data.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching users. Please try again.');
        });
    };

    return execute_query();
}
